module.exports = __webpack_public_path__ + "img/ic_share_tw.49da078d.svg";